import {useBooleanState} from '@wandb/common/util/hooks';
import React, {FC, memo, useCallback} from 'react';
import styled from 'styled-components';

import {ActivationMethods} from '../../../services/analytics/types';
import {useIsAdminModeActiveAndIsNotLocalEnv} from '../../../util/admin';
import {isMac} from '../../../util/browser';
import {IconSearch} from '../../Icon';
import KeyboardShortcut from '../../KeyboardShortcut';
import {useNavContext, useNavUpdaterContext} from '../../NavContextProvider';
import {Tooltip} from '../../Tooltip';
import {useSearchNavAnalytics} from '../useSearchNavAnalytics';
import {Button, Wrapper} from './NavResources';

const NavSearchButtonComp: FC = () => {
  const {searchActive} = useNavContext();
  const {toggleSearch} = useNavUpdaterContext();
  const {trackSearchNavOnScreen, trackAppLauncherOnScreen} =
    useSearchNavAnalytics();
  const {
    state: tooltipOpen,
    setTrue: openTooltip,
    setFalse: closeTooltip,
  } = useBooleanState(false);

  const onClick = useCallback(() => {
    if (!searchActive) {
      trackSearchNavOnScreen(ActivationMethods.MouseClick);
      trackAppLauncherOnScreen(ActivationMethods.MouseClick);
    }
    toggleSearch();
  }, [
    searchActive,
    toggleSearch,
    trackSearchNavOnScreen,
    trackAppLauncherOnScreen,
  ]);

  const showAdminBanner = useIsAdminModeActiveAndIsNotLocalEnv();

  return (
    <Wrapper onClick={onClick} marginRight={7}>
      <Tooltip
        position="bottom center"
        open={tooltipOpen && !searchActive}
        onOpen={openTooltip}
        onClose={closeTooltip}
        trigger={
          <Button active={searchActive} showAdminBanner={showAdminBanner}>
            <Icon />
          </Button>
        }>
        Global search <Shortcut keys={[isMac ? `Cmd` : `Ctrl`, `K`]} />
      </Tooltip>
    </Wrapper>
  );
};

const NavSearchButton = memo(NavSearchButtonComp);

export default NavSearchButton;

const Icon = styled(IconSearch)`
  display: block;
  width: 24px;
  height: 24px;
`;

const Shortcut = styled(KeyboardShortcut)`
  margin-left: 10px;
`;
